import { Box, styled } from "@mui/material";
import React from "react";

import { Footer } from "../Footer";
import ContentHeader from "./ContentHeader";

const StyledBackground = styled(Box)`
  background-color: ${(props) => props.theme.palette.primary.contrastText};
`;

const StyledBox = styled(Box)`
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: ${(props) => props.theme.spacing(6)} 0;
  }
`;

type Props = {
  children?: React.ReactNode;
};

export const ContentLayout = ({ children }: Props) => {
  return (
    <StyledBackground>
      <ContentHeader />
      <StyledBox>{children}</StyledBox>
      <Footer />
    </StyledBackground>
  );
};
